import { Component, Input, inject, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { NgMultiSelectDropDownModule, IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
	selector: 'app-user-form',
	imports: [CommonModule, FormsModule, NgMultiSelectDropDownModule],
  providers: [DatePipe],
	templateUrl: './user-form.component.html',
	styleUrl: './user-form.component.scss',
})
export class UserFormComponent {
  @Input() user: any;
  @Input() action: any;

  dropdownList: any[] = [];
  selectedItems: any[] = [];
  dropdownSettings: IDropdownSettings = {};

  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');

  base = 'users';		// important for API calls
  loading = false;
  headers: any = null;
	isReadonly = true;
  newPassword: string = '';
  institutes: any = [];
  staff     = signal<any> ([]);

  frmDataX: any = {};
  frmData: any = {
		id: null, 
		erp_key: '', 
		display_name: '', 
		user_name: '', 
		password_hash: '', 
		user_role: [],
		cur_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
		is_active: true
	};

  constructor(public dataService: DataService) {
    //
  }

  async ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    this.frmData.erp_key = this.user.erp_key;
		this.loading = true;

    for(let i=0; i<this.dataService.user_roles.length; i++) {
      const roles: any = this.dataService.user_roles[i];

      if(roles.code !== "spr") {
        this.dropdownList.push(roles);
      }
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'code',
      textField: 'name',
      itemsShowLimit: 4,
      limitSelection: 4,
      allowSearchFilter: false
    };

    // this.dataService.getAllRecords('institutes').then((res: any) => {
    //   this.institutes = res;
    //   this.loading = false;
    // });

    // Listen to changes continuously
    this.dataService.outerAction.subscribe((value: any) => {
      if(value) {
        if(value.component != 'user') return;

        this.action = value.action;
        this.frmData = value.data ? Object.assign({}, value.data) : this.resetForm();

        if(value.action == 'edit') {          
          if(typeof this.frmData.user_role == 'string') {
            const firstChar = this.frmData.user_role.substr(0,1);
            if(firstChar=="{") {
              let badJsonString: any = this.frmData.user_role;
              const cleanArray = badJsonString.slice(2, -2).split('}","{');
              const parsedData = cleanArray.map((item:any) => {
                const validJsonStr = item.replace(/\\"/g, '"');
                return JSON.parse(validJsonStr);
              });

              this.frmData.user_role = parsedData;
            }
          }

          this.selectedItems = this.frmData.user_role;
        }

        this.dataService.updateOuterAction(null);   //reset value
      }
    });

		this.loading = true;
    await this.dataService.getAllRecords('staff').then((res: any) => {
      this.staff.set(res);
      this.loading = false;
    });


	}

  ngOnChanges() {
    if(this.action) {
      switch(this.action) {
        case 'addnew':
          this.isReadonly = false;
          // this.frmDataSet();
          this.resetForm();
          break;
        case 'modify':
          this.isReadonly = false;
          this.frmDataSet();
          break;
        case 'save':
          this.doSave();
          this.isReadonly = true;
          break;
        case 'update':
          this.doUpdate();
          this.isReadonly = true;
          break;
        case 'cancel':
          this.isReadonly = true;
          this.resetForm();
          break;
        default:
          break;
      }

      this.action = '';
    }
  }

  frmDataSet() {
    if(this.frmData.org_name) {
      this.frmDataX = Object.assign({}, this.frmData);
    } else {
      this.frmDataX = {};
    }
  }

	resetForm() {
    this.newPassword = '';
		this.frmData = {
      id: null, 
      erp_key: this.user.erp_key || '',
      display_name: '', 
      user_name: '', 
      password_hash: '', 
      user_role: [],
      cur_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true
		};
	}

  doSave() {
    this.loading = true;
    // this.frmData.user_role = JSON.stringify(this.frmData.user_role);

    if(this.newPassword) {
      this.frmData.password_hash = this.newPassword;
    }

    this.frmData.erp_key = this.user.erp_key;

    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('create', 'user', 'New user "'+this.frmData.user_name+'" added.');
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;
    // this.frmData.user_role = JSON.stringify(this.frmData.user_role);
    // if(this.newPassword) {
    //   this.frmData.password_hash = this.newPassword;
    // }

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('update', 'user', 'Update user "'+this.frmData.user_name+'" details.');
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

}
